import { useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { ActionButtons } from './action-buttons';
import { MarkdownRendererInlineEdit } from '@/components/shared/markdown-renderer-inline-edit';
import { Modes } from '@/components/shared/markdown-renderer-inline-edit/interfaces';
import { ResourceTypes } from '@/data/learning-path/interfaces';
import { DeleteItemDialog } from '@/packages/learning-path/pages/path-management/components/delete-item-dialog';
import { ResourceBlock } from '@/packages/learning-path/pages/path-management/pages/edit-path/components/resource-block';
import { useManagePath } from '@/packages/learning-path/pages/path-management/pages/edit-path/context';

export const Content = () => {
  const { contents, updateBlock, removeBlock } = useManagePath();
  const [deleteDialogBlockId, setDeleteDialogBlockId] = useState<string | null>(
    null
  );

  const handleMarkdownSave = (newMarkdown: string, id: string) =>
    updateBlock(id, {
      content: { body: newMarkdown },
    });

  return (
    <>
      {contents.map((block) => (
        <Box key={block.id} my={2}>
          {block.type === ResourceTypes.Text && (
            <Box mb={2}>
              <Box
                sx={{
                  border: '1px solid',
                  borderColor: 'divider',
                  p: 2,
                }}
              >
                <MarkdownRendererInlineEdit
                  initialMode={
                    block?.content?.body ? Modes.viewing : Modes.editing
                  }
                  editable
                  markdown={block.content.body}
                  onSave={(newMarkdown) =>
                    handleMarkdownSave(newMarkdown, block.id)
                  }
                />
              </Box>
              <Stack direction="row" justifyContent="flex-end">
                <Button
                  color="error"
                  onClick={() => setDeleteDialogBlockId(block.id)}
                >
                  Excluir seção
                </Button>
              </Stack>
            </Box>
          )}
          {block.type === ResourceTypes.ResourceGroup && (
            <ResourceBlock blockId={block.id} />
          )}
        </Box>
      ))}
      <ActionButtons />
      {deleteDialogBlockId && (
        <DeleteItemDialog
          onClose={() => setDeleteDialogBlockId(null)}
          onSubmit={() => {
            removeBlock(deleteDialogBlockId);
            setDeleteDialogBlockId(null);
          }}
        />
      )}
    </>
  );
};
